import React from 'react'
import Button from './../../Common/Button/Button';
import CommunityImg from '../../../../../sustainability/src/components/Sustainability/CommunityImg/CommunityImg';
import MediaPublicationImg from '../../../images/pages_partner_media_publication.svg';
import rightArrow from './../../../images/Arrow-Right.svg';
import './MediaPublication.scss';

const MediaPublication = () => {

  const openLink = () => window.open(`http://app.impact.com/campaign-campaign-info-v2/noissue.brand?io=4t0eDv%2BVqojUTjr8gdIrSZhXSkGmUzqHRgSLOVuhHG%2FcMc6zOylZREWZv9ljL6%2Bq`, '_blank', 'noopener');

  return (
    <div className="media-publication-wrapper">
      <div className="left-section">
        <h2 className="heading">
          Media Publications
        </h2>
        <div className="sub-heading">
          Are you an online medium (publication, newsletter, podcast, personal blog, etc) interested in highlighting noissue? Onboard into our partner program, utilize your unique tracking link, and receive a commission for all qualified sales.  
        </div>
        <div className="button-container">
          <Button bgColor="#FD566F" label="Apply Now" imgSrc={rightArrow} onClick={openLink} />
        </div>
      </div>
      <div className="right-section">
        <CommunityImg src={MediaPublicationImg} />
      </div>
    </div>
  )
}

export default MediaPublication;